import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { configureChains, createClient, WagmiConfig } from "wagmi";
import { polygonMumbai } from "@wagmi/chains";
import 'bootstrap/dist/css/bootstrap.min.css';
import { songbird } from "./songbird.ts";
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum';
import { Web3Modal } from '@web3modal/react';

const root = ReactDOM.createRoot(document.getElementById('root'));

const projectId = '3ca0a27fb097ca4a1dc56216e09a9cdc'

const chains = [songbird]

const { provider } = configureChains(
  chains, [w3mProvider({ projectId })]
)

const client = createClient({
  autoConnect: true
  , provider,
  connectors: w3mConnectors({ projectId, version: 1, chains })
})

const ethereumClient = new EthereumClient(client, chains)

root.render(
  <>
    <WagmiConfig client={client}>
      <App />
    </WagmiConfig>
    <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />
  </>
);